// extracted by mini-css-extract-plugin
export default {"list":"list--XA8iP","removeButton":"removeButton--f_9Bg","active":"active--dwI_B","nameHolder":"nameHolder--Xb0Tz","name":"name--rukSg"};